import { Task, VisibleColumnSpec } from "@/types";

export const SNAPSHOT_TASK_COLUMNS: VisibleColumnSpec<Task, "actions" | "statusIcon" | "mobile-actions">[] = [
  "type",
  "dueDate",
  { id: "salesItem", breakpoint: "mantine-visible-from-sm" },
  { id: "counterParty", breakpoint: "mantine-visible-from-md" },
  "status",
  "actions",
  { id: "mobile-actions", breakpoint: "mantine-hidden-from-xs" },
];
